<template>
  <base-modal
    class="media_modal"
    @close="$emit('close')"
  >
    <template #heading>
      Ranking keywords
    </template>

    <div v-if="loading">
      Loading <i class="fas fa-spin fa-spinner" />
    </div>

    <div
      v-if="error"
      class="text-danger"
    >
      Something went wrong fetching the ranking keywords for this page. Please close this modal and try again.
    </div>

    <h3 v-if="chosenKeywordRankings?.length > 0">
      Chosen keywords this page is ranking for
    </h3>
    <div
      v-if="chosenKeywordRankings?.length > 0"
      class="table_wrap"
    >
      <table>
        <thead>
          <tr>
            <th>Keyword</th>
            <th>Position</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(keyword, index) in chosenKeywordRankings"
            :key="index"
          >
            <td>{{ keyword.keyword }}</td>
            <td>{{ keyword.position }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <h3 v-if="otherKeywordRankings?.length > 0">
      Other keywords we've spotted ranking for this page
    </h3>
    <div
      v-if="otherKeywordRankings?.length > 0"
      class="table_wrap"
    >
      <table>
        <thead>
          <tr>
            <th>Keyword</th>
            <th>Position</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(keyword, index) in otherKeywordRankings"
            :key="index"
          >
            <td>{{ keyword.keyword }}</td>
            <td>{{ keyword.position }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </base-modal>
</template>

<script>
import BaseModal from "../../global/modals/BaseModal";
import axios from "axios";

export default {
  components: {
    BaseModal,
  },
  props: {
    pageUrl: {
      type: String,
      required: true,
    },
  },
  emits: [
    'close',
  ],
  data() {
    return {
      chosenKeywordRankings: false,
      otherKeywordRankings: false,
      loading: false,
      error: false,
    }
  },
  mounted() {
    this.getRankingKeywords();
  },
  methods: {
    getRankingKeywords() {
      const { pageUrl } = this;
      this.loading = true;

      axios.post('/ajax/keywords/ranking', {
        pageUrl,
      }).then(({ data }) => {
        this.chosenKeywordRankings = data.chosenKeywordRankings;
        this.otherKeywordRankings = data.otherKeywordRankings;
        this.loading = false;
      }).catch(() => {
        this.loading = false;
        this.error = true;
      });
    }
  }
}

</script>

<style lang="scss" scoped>
:deep(.modal_window) {
  max-width: 600px;
}
.table_wrap {
  max-height: 30vh;
  overflow-y: auto;

  table {
    width: 100%;

    th, td {
      padding: 1rem;
      width: 50%;
      text-align: center;
    }

    th {
      font-size: 16px;
      font-weight: 500;
      line-height: 26px;
      letter-spacing: -0.25px;
    }

    tbody tr:nth-of-type(2n+1) {
      background: var(--table-secondary-color);
    }
  }
}
</style>
